import { combineReducers } from "redux";
import { TimerActionKey } from "../../actions/ActionKeys";
import { TimerAction } from "../../actions/timer";

const isRunning = (state = false, action: TimerAction) => {
  switch (action.type) {
    case TimerActionKey.TIMER_START:
      return true;
    case TimerActionKey.TIMER_RESET:
      return false;
    default:
      return state;
  }
};

const initialEpochTime = (state: number | null = null, action: TimerAction) => {
  switch (action.type) {
    case TimerActionKey.TIMER_START:
      return action.payload.initialEpochTime;
    case TimerActionKey.TIMER_RESET:
      return 0;
    default:
      return state;
  }
};

const sessionTimeoutSeconds = (
  state: number = 0,
  action: TimerAction
) => {
  switch (action.type) {
    case TimerActionKey.SET_SESSION_TIMEOUT_SECONDS:
      return action.payload.sessionTimeoutSeconds;
    default:
      return state;
  }
};

export const timer = combineReducers({
  isRunning,
  initialEpochTime,
  sessionTimeoutSeconds,
});
